import { useEffect, useState } from "react";

const PrivateRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const API_URL_LOGIN = process.env.REACT_APP_API_URL_LOGIN;
  const LOGIN_URL = process.env.REACT_APP_KEYCLOAK_LOGIN_URL;

  useEffect(() => {
    const checkToken = async () => {
      const token = localStorage.getItem("token");

      if (!token) {
        if (LOGIN_URL) {
          window.location.replace(LOGIN_URL);
        }
        return;
      }

      try {
        const response = await fetch(`${API_URL_LOGIN}/auth/me/client`, {
          method: "GET",
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        });

        const data = await response.json();

        if (response.ok && data.ok) {
          // Robust mapping of user data
          const userObj = data.user || data.data?.user || {};
          const authObj = data.authorization || data.data?.authorization || [];

          // Compare with existing local user before overwriting to verify identity
          const localUserStr = localStorage.getItem("user");
          if (localUserStr) {
            try {
              const localUser = JSON.parse(localUserStr);
              if (localUser && (localUser.id !== userObj.id || localUser.username !== userObj.username)) {
                console.warn("Security warning: Identity mismatch detected.");
                throw new Error("Identity mismatch");
              }
            } catch (e) {
              if (e.message === "Identity mismatch") throw e;
            }
          }

          localStorage.setItem("user", JSON.stringify(userObj));
          localStorage.setItem("authorization", JSON.stringify(authObj));
          setIsAuthenticated(true);
        } else {
          throw new Error("Invalid token or unauthorized");
        }
      } catch (err) {
        localStorage.clear();
        if (LOGIN_URL) {
          window.location.replace(LOGIN_URL);
        }
      }
    };

    checkToken();
  }, [API_URL_LOGIN, LOGIN_URL]);

  if (isAuthenticated === null) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-zinc-950">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary mb-4 mx-auto"></div>
          <p className="text-zinc-600 dark:text-zinc-400">Verificando sesión...</p>
        </div>
      </div>
    );
  }

  return isAuthenticated ? children : null;
};

export default PrivateRoute;
